import { render } from "./topicAdd.vue?vue&type=template&id=384e172c&scoped=true"
import script from "./topicAdd.vue?vue&type=script&lang=js"
export * from "./topicAdd.vue?vue&type=script&lang=js"

import "./topicAdd.vue?vue&type=style&index=0&id=384e172c&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-384e172c"]])

export default __exports__